import { Vec3 } from "../models/SyntheticMap";
import { Visual } from "../models/Visual";
import { ArmAnimator } from "./ArmAnimator";
import { BaseAnimator } from "./BaseAnimator";
import { RobotData, RobotVisual } from "./RobotVisual";
import * as THREE from "three";
import { copyVec3, vectorFromParentToChildLocal } from "./visual-utils";
import { CameraConfig } from "./ModelBasedVisual";
import { ArmJointRole, ArmMotionMapper } from "../models/Model";

export interface ArmData extends RobotData {
  parentId: string;
  idlePosition: Vec3;
}

export class ArmVisual extends RobotVisual implements ArmData {
  parentId = '';
  idlePosition = { x: 0, y: 0, z: 0.5 };
  
  public getType(): string {
    return 'ArmVisual';
  }

  public createDataTemplate(): Visual {
    const data: ArmData = {
      type: this.getType(),
      _id: this._id,
      id: this.id,
      position: this.position,
      rotation: this.rotation,
      orgId: this.orgId,
      siteAnchorId: this.siteAnchorId,
      modelId: this.modelId,
      robotId: this.robotId,
      location: this.location,
      parentId: this.parentId,
      idlePosition: this.idlePosition,
      visualizeSensors: this.visualizeSensors,
      floorId: this.floorId,
    };
    return data;
  }

  public armAnimator(): ArmAnimator {
    return this.animator as ArmAnimator;
  }

  public sceneAdjust(): void {
    if (this.parentId) {
      const visParent = this.getParentVisual();
      if (visParent && visParent._id === this.parentId) {
      } else {
        const parent = this.wr.dataService.visuals.get(this.parentId);
        if (parent) {
          // Adjust position/rotation based on parent
          const attachPoint = new THREE.Vector3(0.2, 0, 0.5); // Define where on the parent the arm attaches
          this.obj.removeFromParent();
          parent.obj.add(this.obj);
          this.obj.position.copy(attachPoint);
          copyVec3(attachPoint, this.position);
          this.obj.rotation.set(0, 0, 0);
          copyVec3(this.obj.rotation, this.rotation);
          this.obj.updateMatrixWorld(true);
        } else {
          console.error('Parent visual not found:', this.parentId);
        }
      }
    }
    this.obj.updateMatrixWorld(true);
    // const idlePos = new THREE.Vector3(this.idlePosition.x, this.idlePosition.y, this.idlePosition.z);
    // const worldIdlePos = this.obj.localToWorld(idlePos.clone());
    // console.log({
    //   idlePos,
    //   worldIdlePos,
    // });
    this.armAnimator().neutralize();
    this.resetArm();
  }

  protected async onLoaded(): Promise<void> {
    await super.onLoaded();
  }

  public updateObj(): void {
    super.updateObj();
    // (this.animator as ArmAnimator).neutralize();    
  }

  public createAnimator(): BaseAnimator {
    return new ArmAnimator(this.modelLoader);
  }

  public moveArm(targetPosition: Vec3): void {
    const site = this.wr.dataService.activeSite!;
    const pos = new THREE.Vector3(targetPosition.x, targetPosition.y, targetPosition.z);
    const localPosition = vectorFromParentToChildLocal(site.obj, this.obj, pos);
    console.log('Moving arm to local position', localPosition);
    this.armAnimator().moveArm(localPosition);
  }

  resetArm() {
    this.armAnimator().moveArm(this.idlePosition);
  }


  public getCameras(): CameraConfig[] {
    const r = this.modelLoader.robot!;
    const mapper = this.modelLoader.model!.motionMapper as ArmMotionMapper;
    const cameraJoint = mapper.joints[ArmJointRole.Camera];
    if (cameraJoint) {
      return [
        {
          position: new THREE.Vector3(0, 0, 0.1),
          rotation: new THREE.Euler(Math.PI, 0, 0),
          fov: 70,
          parent: r.joints[cameraJoint.name],
          name: 'Arm Camera'
        }
      ];
    }
    return [];
  }
}
